// @ts-nocheck
import { io } from 'socket.io-client'

import { environment } from './environment'

const URL = environment.SOCKETURL

export const socket = io(URL, {
  path: '/socket',
  transports: ['websocket', 'polling'],
})
